import { Col, Row } from '@/app/components/Flex/Flex'
import { Motion } from '@/app/components/Motion/Motion'
import { Text } from '@/app/components/Text/Text'
import { UI } from '@/app/components/UI/UI'
import type { FunctionalComponent } from 'preact'
import styles from './index.module.scss'

export const Lib: FunctionalComponent & {
  SystemMessage: FunctionalComponent<{
    hover?: boolean
    link?: string
  }>
  Errors: FunctionalComponent<{
    errors: string[]
  }>
  PopupHeader: FunctionalComponent
  PopupMessage: FunctionalComponent
  Fields: FunctionalComponent
} = () => {
  return (
    <div class={styles.root}>
    </div>
  )
}

Lib.SystemMessage = props => (
  <UI.Panel
    link={props.link}
    hover={props.hover}
  >
    <Text fontSize={16}>
      {props.children}
    </Text>
  </UI.Panel>
)

Lib.Errors = props => (
  props.errors.map(error => (
    <Motion key={error}>
      <UI.Panel type='error'>
        <Text fontSize={16}>
          {error}
        </Text>
      </UI.Panel>
    </Motion>
  ))
)

Lib.PopupHeader = props => (
  <Text
    fontSize={20}
    fontSizeMobile={18}
    fontWeight={600}
    textAlign='center'
  >
    {props.children}
  </Text>
)

Lib.PopupMessage = props => (
  <Col justifyContent='center'>
    <Text fontSize={16}>
      {props.children}
    </Text>
  </Col>
)

Lib.Fields = props => (
  <Row gap={10}>
    {props.children}
  </Row>
)
